export const styles = {
  gridColum: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: 25,
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-end",
    margin: 0,
    padding: 0,
    height: 370,
  },
  divContent: {
    display: "flex",
    backgroundColor: "transparent",
    backgroundImage: "linear-gradient(to bottom, transparent, #3B3B3B)",
    width: "100%",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "flex-start",
    padding: 10,
  },
  cardHeader: {
    color: "white",
    fontSize: 20,
    fontWeight: "bold",
    textShadow: "1px 0 black",
  },
  spam: {
    color: "white",
    fontSize: 12,
    fontWeight: "bold",
  },
};
